import PropTypes from "prop-types";
import { useScreens } from "@utils/component";
import { Map, Marker } from "@components/map";

import { Cards } from "./cards";

export function Overview({ pois }) {
  const { screen } = useScreens();

  return (
    <div>
      <div className="relative grid grid-cols-3 grid-rows-3 md:gap-3 h-88 md:h-[550px]">
        <div className="col-span-3 col-start-1 row-start-1 row-end-4 md:col-start-2">
          <Map
            className="overflow-hidden rounded"
            boundsPadding={screen === "sm" && { bottom: 175 }}
          >
            {pois.map((poi, i) => (
              <Marker
                key={poi.esid}
                lat={poi.meta.coords.lat}
                lng={poi.meta.coords.lon}
                index={i + 1}
              />
            ))}
          </Map>
        </div>

        <div className="z-10 col-start-1 col-end-4 row-start-3 row-end-4 md:col-end-2 md:row-start-1">
          <Cards pois={pois} />
        </div>
      </div>
    </div>
  );
}

Overview.propTypes = {
  pois: PropTypes.arrayOf(
    PropTypes.shape({
      esid: PropTypes.string,
      title: PropTypes.string,
      slug: PropTypes.string,
      editorial: PropTypes.string,
      image: PropTypes.shape({
        src: PropTypes.string,
        credit: PropTypes.string,
        alt: PropTypes.string,
      }),
      meta: PropTypes.shape({
        address: PropTypes.string,
        coords: PropTypes.shape({
          lat: PropTypes.number,
          lon: PropTypes.number,
        }),
        tags: PropTypes.arrayOf(
          PropTypes.shape({ slug: PropTypes.string.isRequired })
        ),
        parent: PropTypes.shape({
          slug: PropTypes.string.isRequired,
        }),
      }),
    })
  ).isRequired,
};
